module.exports = __webpack_public_path__ + "static/media/ThoughtLeadership_Post02-Image.64d90d01.jpg";